// extracted by mini-css-extract-plugin
export default {"avatarUserIcon":"Avatar_avatarUserIcon__lup9o","root":"Avatar_root__aA8F2"};